import React from 'react';

export const PartnersCarousel = ({ partners }) => {
  // Duplicate partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners];

  return (
    <div className="partners-scroll-container">
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .partners-scroll-container {
          background: #f9fafb;
          padding: 40px 0;
          overflow: hidden;
          position: relative;
        }

        .partners-scroll-wrapper {
          display: flex;
          width: max-content;
          animation: scroll 40s linear infinite;
        }

        .partners-scroll-wrapper:hover {
          animation-play-state: paused;
        }

        .partner-logo-item {
          flex: 0 0 auto;
          width: 220px;
          margin: 0 15px;
        }

        .partner-logo-box {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 130px;
          padding: 30px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
        }

        .partner-logo-box:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.15);
          transform: translateY(-4px);
        }

        .partner-logo-img {
          height: 80px;
          width: 190px;
          object-fit: contain;
          filter: grayscale(100%) opacity(0.6);
          transition: filter 0.3s ease;
        }

        .partner-logo-box:hover .partner-logo-img {
          filter: grayscale(0%) opacity(1);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .partner-logo-item {
            width: 180px;
          }
          .partner-logo-box {
            height: 80px;
            padding: 15px;
          }
          .partner-logo-img {
            height: 40px;
            width: 120px;
          }
        }
      `}</style>
      
      <div className="partners-scroll-wrapper">
        {duplicatedPartners.map((partner, index) => (
          <div key={`${partner.name}-${index}`} className="partner-logo-item">
            <div className="partner-logo-box">
              <img
                src={partner.logo}
                alt={partner.name}
                className="partner-logo-img"
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
